<template>
  <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
    <vx-card title="รายการบทความ">
      <vs-td>
        <vs-button :disabled="$store.state.AppActiveUser.permissions.setting.action ? false : true" type="border"
          size="small" icon-pack="feather" icon="icon-edit" class="mr-2 mb-4" @click="clearData(), popupInfo('ADD')">
          เพิ่มบทความ </vs-button>
      </vs-td>
      <vs-table :data="infoSettingMessage">
        <template slot="thead">
          <vs-th>
            ลำดับ
          </vs-th>
          <vs-th>
            ชื่อบทความ
          </vs-th>
          <vs-th>
            รายละเอียดบทความ
          </vs-th>
          <vs-th>
           แสดงหน้าเว็บ
          </vs-th>
          <vs-th>
            รูปด้านหน้า
          </vs-th>
          <vs-th>
            รูปภาพด้านในบทความ
          </vs-th>
          <vs-th>
            Tags
          </vs-th>
          <vs-th>
            
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.blog_id">
              {{ tr.blog_id }}
            </vs-td>
            <vs-td :data="tr.blog_name">
              {{ cutString(tr.blog_name) }}
            </vs-td>
            <vs-td :data="tr.blog_info">
              {{ cutString(tr.blog_info) }}
            </vs-td>
            <vs-td :data="tr.blog_status">
              <vs-switch :disabled="$store.state.AppActiveUser.permissions.setting.action ? false : true"
                v-model="tr.blog_status" @click="update_status(tr.blog_id, tr.blog_status)">
                <span slot="on">เปิด</span>
                <span slot="off">ปิด</span>
              </vs-switch>
            </vs-td>

            <vs-td :data="tr.sms_service_provider">
              <img :src="tr.blog_url" alt="Blog Image" style="width: 100px; height: 100px;">
            </vs-td>

            <vs-td :data="tr.blog_image">
              <img :src="tr.blog_photo" alt="Blog Image" style="width: 100px; height: 100px;">
            </vs-td>

            <vs-td :data="tr.blog_tags">
              <div v-if="getTagsArray(tr.blog_tags).length > 0" class="flex flex-wrap gap-1">
                <vs-chip 
                  v-for="(tag, tagIndex) in getTagsArray(tr.blog_tags)" 
                  :key="tagIndex" 
                  color="primary"
                  size="small">
                  {{ tag }}
                </vs-chip>
              </div>
              <span v-else class="text-muted">-</span>
            </vs-td>

            <vs-td>
              <div style="display: flex; align-items: center">
                <vs-button :disabled="$store.state.AppActiveUser.permissions.setting.action ? false : true"
                  type="border" class="mr-2" size="small" icon-pack="feather" color="warning" icon="icon-edit"
                  @click="popupInfo('EDIT', tr)">แก้ไข</vs-button>
                <vs-button :disabled="$store.state.AppActiveUser.permissions.setting.action ? false : true"
                  type="border" class="mr-2" size="small" icon-pack="feather" color="success" icon="icon-eye"
                  @click="popupInfo('SHOW', tr)">แสดง</vs-button>
                <vs-button :disabled="$store.state.AppActiveUser.permissions.setting.action ? false : true"
                  type="border" size="small" icon-pack="feather" color="danger" icon="icon-eye"
                  @click="popupDelete('DELETE', tr)">ลบ</vs-button>
              </div>

            </vs-td>
            <vs-td>

            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <vs-popup classContent="popup-example" :title="`${this.infopopup.type} MESSAGES`" :active.sync="showpopup">
      <div v-if="this.infopopup.type != 'SHOW'">
        <div class="flex flex-wrap gap-2 mb-4">
        </div>
        <div class="mb-4">
          <div class="flex items-center justify-between mb-2">
            <label class="vs-input--label">ชื่อบทความ</label>
            <vs-button 
              v-if="this.infopopup.type != 'SHOW'"
              type="border" 
              size="small" 
              icon-pack="feather" 
              icon="icon-plus" 
              class="ml-2"
              @click="openTagModal">
              ADD TAG
            </vs-button>
          </div>
          <quill-editor 
            v-model="infopopup.blog_name" 
            :options="editorOptions"
            class="blog-quill-editor" />
          <div v-if="tags.length > 0" class="flex flex-wrap gap-2 mt-2">
            <vs-chip 
              v-for="(tag, index) in tags" 
              :key="index" 
              closable
              @click="removeTag(index)"
              color="primary">
              {{ tag }}
            </vs-chip>
          </div>
        </div>

        <div class="flex flex-wrap gap-2 mb-4">
        </div>
        <div class="mb-4">
          <label class="vs-input--label">รายละเอียดบทความด้านหน้า</label>
          <quill-editor 
            v-model="infopopup.blog_info" 
            :options="editorOptions"
            class="blog-quill-editor" />
        </div>

        <div class="flex flex-wrap gap-2 mb-4">
        </div>
        <div class="mb-4">
          <label class="vs-input--label">เนื้อหาบทความด้านใน</label>
          <quill-editor 
            v-model="infopopup.text" 
            :options="editorOptions"
            class="blog-quill-editor" />
        </div>
      </div>
      <div v-else class="mb-4">
        <div class="flex flex-wrap gap-2 mb-4">
        </div>
        <div class="mb-4">
          <label class="vs-input--label">ชื่อบทความ</label>
          <quill-editor 
            v-model="infopopup.blog_name" 
            disabled
            :options="editorOptions"
            class="blog-quill-editor" />
          <div v-if="tags.length > 0" class="flex flex-wrap gap-2 mt-2">
            <vs-chip 
              v-for="(tag, index) in tags" 
              :key="index" 
              color="primary">
              {{ tag }}
            </vs-chip>
          </div>
        </div>

        <div class="flex flex-wrap gap-2 mb-4">
        </div>
        <div class="mb-4">
          <label class="vs-input--label">รายละเอียดบทความด้านหน้า</label>
          <quill-editor 
            v-model="infopopup.blog_info" 
            disabled
            :options="editorOptions"
            class="blog-quill-editor" />
        </div>
        <label class="vs-input--label">เนื้อหาบทความ</label>
        <quill-editor 
            v-model="infopopup.text" 
            disabled
            :options="editorOptions"
            class="blog-quill-editor" />
        <!-- <div class="p-4 border bg-white rounded" v-html="infopopup.text || '<em>ไม่มีข้อความ</em>'"></div> -->
      
      </div>
      <div v-if="this.infopopup.type == 'SHOW'">
        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 mb-4">
          <label class="vs-input--label mb-2" style="display: block;">รูปด้านหน้า</label>
          <img :src="infopopup.blog_url" alt="Blog Image" style="width: 100px; height: 100px; display: block;">
        </div>
        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 mb-4">
          <label class="vs-input--label mb-2" style="display: block;">รูปภาพด้านในบทความ</label>
          <img :src="infopopup.blog_photo" alt="Blog Image" style="width: 100px; height: 100px; display: block;">
        </div>
      </div>
      <div v-else>
          <label> อัพรูปบทความด้านหน้า COPY & PASTE </label>
           <div class="mt-4">
           <vs-input class="inputx" placeholder="กรุณาวางรูป" :value="selectedFileUrlName" @paste="onPasteUrl"/>
           <vs-checkbox disabled="true" class="mt-4" :color="chk_box_url.color" v-model="chk_box_url.data">{{chk_box_url.text}}</vs-checkbox>
           <canvas  style="border:1px solid grey;" id="mycanvas-url" width="100" height="100" ></canvas>
           </div>

           <label> อัพรูปบทความด้านใน COPY & PASTE </label>
           <div class="mt-4">
           <vs-input class="inputx" placeholder="กรุณาวางรูป" :value="selectedFilePhotoName" @paste="onPastePhoto"/>
           <vs-checkbox disabled="true" class="mt-4" :color="chk_box_photo.color" v-model="chk_box_photo.data">{{chk_box_photo.text}}</vs-checkbox>
           <canvas  style="border:1px solid grey;" id="mycanvas-photo" width="100" height="100" ></canvas>
           </div>
      </div>

      <div class="flex flex-wrap gap-2 mb-4" v-if="this.infopopup.type != 'SHOW'">
        <vs-input class="w-full" label-placeholder="OTP" v-model="infopopup.otp"  name="Newturn" />
        <small class="text-danger" >กรุณากรอก OTP ทุกครั้งเพื่อยืนยันการแก้ไข</small>
      </div>
     
      <br>
      <vs-button v-if="this.infopopup.type != 'SHOW'"
        :disabled="$store.state.AppActiveUser.permissions.setting.action ? false : true" size="small"
        icon-pack="feather" icon="icon-edit" class="mr-2 mt-4" @click="confirm_edit(infopopup.type)">ยืนยัน</vs-button>
    </vs-popup>

    <!-- Add Tag Modal -->
    <vs-popup classContent="popup-tag-modal" title="Add Tag" :active.sync="showTagModal">
      <div class="mb-4">
        <vs-input 
          v-model="newTag" 
          placeholder="กรุณากรอก Tag"
          class="w-full"
          @keyup.enter="addTag" />
      </div>
      <div class="flex justify-end gap-2">
        <vs-button 
          type="border" 
          size="small"
          @click="closeTagModal">
          CANCEL
        </vs-button>
        <vs-button 
          type="filled" 
          size="small"
          @click="addTag">
          OK
        </vs-button>
      </div>
    </vs-popup>

    <vs-popup classContent="popup-example" :title="`${this.infopopup.type} MESSAGES`" :active.sync="showpopupDelete">


      <div class="mb-4">
        <label class="vs-input--label">เนื้อหาบทความ </label>
        <div class="p-4 border bg-white rounded" v-html="infopopup.text || '<em>ไม่มีข้อความ</em>'"></div>
      </div>

        <vs-input class="w-full" label-placeholder="OTP" v-model="infopopup.otp"  name="Newturn" />
        <small class="text-danger" >กรุณากรอก OTP ทุกครั้งเพื่อยืนยันการลบ</small>
      <p>หากต้องการลบ ข้อความนี้กรุณากดปุ่ม "ยืนยัน"</p>

      <br>
      <vs-button :disabled="$store.state.AppActiveUser.permissions.setting.action ? false : true" size="small"
        icon-pack="feather" icon="icon-edit" class="mr-2 mt-4" @click="deleteMessage(infopopup.blog_id)">ยืนยัน</vs-button>
    </vs-popup>
  </div>
</template>


<script>
import axios from '../../../axios'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import moment from 'moment'
// import {
//   Validator
// } from 'vee-validate'

// const dict = {
//   custom: {
//     message: {
//       required: 'กรุณากรอกข้อมูล',
//       max: 'กรุณากรอกตัวอักษรไม่เกิน70ตัว'
//     }
//   }
// }
// Validator.localize('en', dict)
export default {
  components: {
    flatPickr,
    quillEditor
  },
  data () {
    return {
      memberData: '',
      searchmember: '',
      infoSettingMessage: '',
      showpopup: false,
      showpopupDelete: false,
      showTagModal: false,
      tags: [],
      newTag: '',
      selectedFile: [],
      selectedFileUrl: [],
      selectedFilePhoto: [],
      chk_box_url: {text: 'กรุณาวางรูป', color: 'danger', data: false},
      chk_box_photo: {text: 'กรุณาวางรูป', color: 'danger', data: false},
      infopopup: {
        text: '',
        blog_name: '',
        blog_info: '',
        blog_url: '',
        blog_photo: '',
        type: '',
        otp: '',
        id: '',
        admin: '',
        datetime: '',
        domain: '',
        website_name: ''
      },
      error: '',
      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'link'],
            [
              {
                color: [
                  'purple',
                  'deepskyblue',
                  'blue',
                  'green',
                  'yellow',
                  'orange',
                  'red'
                ]
              }
            ],
            [
              {
                header: [1, 2, 3, 4, 5, 6, false]
              }
            ]
          ]
        },
        theme: 'snow'
      }
    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    },
    // currentWebsite () {
    //   return this.$store.state.currentWebsite
    // },
    selectedFileUrlName () {
      if (this.selectedFileUrl && this.selectedFileUrl.name) {
        return this.selectedFileUrl.name
      } else if (this.selectedFileUrl && Object.keys(this.selectedFileUrl).length > 0) {
        return 'รูปภาพที่วางแล้ว'
      }
      return ''
    },
    selectedFilePhotoName () {
      if (this.selectedFilePhoto && this.selectedFilePhoto.name) {
        return this.selectedFilePhoto.name
      } else if (this.selectedFilePhoto && Object.keys(this.selectedFilePhoto).length > 0) {
        return 'รูปภาพที่วางแล้ว'
      }
      return ''
    }
  },
  watch: {
    // currentWebsite (newWebsite, oldWebsite) {
    //   if (newWebsite && oldWebsite && newWebsite.value !== oldWebsite.value) {
    //     this.callinfo()
    //   } else if (newWebsite && newWebsite.value && !oldWebsite) {
    //     // เมื่อ component mount ครั้งแรก
    //     this.callinfo()
    //   }
    // },
    selectedFileUrl () {
      if (this.selectedFileUrl && this.selectedFileUrl.name && this.selectedFileUrl.name.length > 0) {
        this.chk_box_url.text = 'วางรูปสำเร็จ'
        this.chk_box_url.color = 'success'
        this.chk_box_url.data = true
      } else if (this.selectedFileUrl && Object.keys(this.selectedFileUrl).length > 0) {
        // ถ้าเป็น Blob object (ไม่มี name property)
        this.chk_box_url.text = 'วางรูปสำเร็จ'
        this.chk_box_url.color = 'success'
        this.chk_box_url.data = true
      } else {
        this.chk_box_url.text = 'กรุณาวางรูป'
        this.chk_box_url.color = 'danger'
        this.chk_box_url.data = false
      }
    },
    selectedFilePhoto () {
      if (this.selectedFilePhoto && this.selectedFilePhoto.name && this.selectedFilePhoto.name.length > 0) {
        this.chk_box_photo.text = 'วางรูปสำเร็จ'
        this.chk_box_photo.color = 'success'
        this.chk_box_photo.data = true
      } else if (this.selectedFilePhoto && Object.keys(this.selectedFilePhoto).length > 0) {
        // ถ้าเป็น Blob object (ไม่มี name property)
        this.chk_box_photo.text = 'วางรูปสำเร็จ'
        this.chk_box_photo.color = 'success'
        this.chk_box_photo.data = true
      } else {
        this.chk_box_photo.text = 'กรุณาวางรูป'
        this.chk_box_photo.color = 'danger'
        this.chk_box_photo.data = false
      }
    },
    showTagModal (newVal) {
      if (newVal) {
        this.$nextTick(() => {
          // Find all popup elements and set z-index
          const popups = document.querySelectorAll('.con-vs-popup')
          popups.forEach((popup) => {
            const content = popup.querySelector('.popup-tag-modal')
            if (content) {
              popup.style.zIndex = '53001'
            }
          })
        })
      }
    }
  },
  mounted () {
    this.callinfo()

  },
  methods: {
    moment,
    callinfo () {
      axios
        .get('/blog/list')
        .then(response => (this.infoSettingMessage = response.data))
    },
    popupInfo (Type, rowData) {
      if (Type === 'EDIT' || Type === 'SHOW') {
        this.infopopup.text = rowData.blog_text || ''
        this.infopopup.blog_name = rowData.blog_name || ''
        this.infopopup.blog_info = rowData.blog_info || ''
        this.infopopup.blog_url = rowData.blog_url || ''
        this.infopopup.blog_photo = rowData.blog_photo || ''
        this.infopopup.admin = rowData.admin || ''
        this.infopopup.blog_id = rowData.blog_id
        this.infopopup.datetime = rowData.datetime || ''
        this.infopopup.domain = rowData.domain || ''
        this.infopopup.website_name = rowData.website_name || ''
        // Load tags if available from blog_tags field
        if (rowData.blog_tags) {
          this.tags = this.getTagsArray(rowData.blog_tags)
        } else {
          this.tags = []
        }
        this.showpopup = true
      } else {
        this.clearData()
        this.showpopup = true
      }
      this.infopopup.type = Type
    },
    popupDelete (Type, rowData) {
      this.infopopup.type = Type
      this.infopopup.text = rowData.blog_text
      this.infopopup.blog_name = rowData.blog_name
      this.infopopup.blog_info = rowData.blog_info
      this.infopopup.text = rowData.blog_text
      this.infopopup.blog_url = rowData.blog_url
      this.infopopup.blog_photo = rowData.blog_photo
      this.infopopup.blog_id = rowData.blog_id
      this.showpopupDelete = true
    },
    async deleteMessage (id) {

      await axios.post('/blog/delete', {
        id,
        token: this.infopopup.otp

      })
        .then(response => (this.error = response.data))

      if (this.error.status === true) {
        this.$vs.notify({
          time: 10000,
          color: 'success',
          position: 'top-right',
          icon: 'error',
          text: this.error.info.title,
          title: 'ทำรายการสำเร็จ'
        })
        this.callinfo()
        this.showpopupDelete = false
      } else {
        this.$vs.notify({
          time: 10000,
          color: 'danger',
          position: 'top-right',
          icon: 'error',
          text: this.error.info.title,
          title: 'ทำรายการผิดพลาด'
        })
        this.showpopupDelete = false
      }
    },
    async confirm_edit (type) {
      if (!this.infopopup.text || this.infopopup.text.trim().length === 0) {
        this.$vs.notify({
          time: 10000,
          color: 'danger',
          position: 'top-right',
          icon: 'error',
          text: 'กรุณากรอกข้อมูล',
          title: 'ทำรายการไม่สำเร็จ'
        })

        return false
      }

      if (type === 'ADD') {
        const formData = new FormData()
        formData.append('file', this.selectedFile)
        formData.append('info', this.infopopup.text)
        formData.append('blog_name', this.infopopup.blog_name)
        formData.append('blog_info', this.infopopup.blog_info)
        formData.append('blog_text', this.infopopup.text)
        formData.append('blog_url', this.selectedFileUrl)
        formData.append('blog_photo', this.selectedFilePhoto)
        formData.append('tags', JSON.stringify(this.tags))
        formData.append('token', this.infopopup.otp)
        await axios.post('/blog/upload', formData)
          .then(response => (this.error = response.data))
      } else {

        const formData = new FormData()
        formData.append('id', this.infopopup.blog_id)
        formData.append('file', this.selectedFile)
        formData.append('info', this.infopopup.text)
        formData.append('blog_name', this.infopopup.blog_name)
        formData.append('blog_info', this.infopopup.blog_info)
        formData.append('blog_text', this.infopopup.text)
        formData.append('blog_url', this.selectedFileUrl)
        formData.append('blog_photo', this.selectedFilePhoto)
        formData.append('tags', JSON.stringify(this.tags))
        formData.append('token', this.infopopup.otp)
        await axios.post('/blog/edit', formData)
          .then(response => (this.error = response.data))
      }

      if (this.error.status === true) {
        this.$vs.notify({
          time: 10000,
          color: 'success',
          position: 'top-right',
          icon: 'error',
          text: this.error.info.title,
          title: 'ทำรายการสำเร็จ'
        })
        this.callinfo()
        this.showpopup = false
      } else {
        this.$vs.notify({
          time: 10000,
          color: 'danger',
          position: 'top-right',
          icon: 'error',
          text: this.error.info.title,
          title: 'ทำรายการผิดพลาด'
        })
        this.showpopup = false
      }
    },
    clearData () {
      this.infopopup.text = ''
      this.infopopup.blog_name = ''
      this.infopopup.blog_info = ''
      this.infopopup.blog_url = ''
      this.infopopup.blog_photo = ''
      this.infopopup.domain = ''
      this.infopopup.website_name = ''
      this.infopopup.otp = ''
      this.tags = []
      this.newTag = ''
    },
    openTagModal () {
      this.newTag = ''
      this.showTagModal = true
    },
    closeTagModal () {
      this.showTagModal = false
      this.newTag = ''
    },
    addTag () {
      if (this.newTag && this.newTag.trim()) {
        const tag = this.newTag.trim()
        // Check if tag already exists
        if (!this.tags.includes(tag)) {
          this.tags.push(tag)
        }
        this.newTag = ''
        this.closeTagModal()
      }
    },
    removeTag (index) {
      this.tags.splice(index, 1)
    },
    getTagsArray (tags) {
      if (!tags) return []
      if (Array.isArray(tags)) return tags
      if (typeof tags === 'string') {
        // Try to parse as JSON first
        try {
          const parsed = JSON.parse(tags)
          return Array.isArray(parsed) ? parsed : []
        } catch (e) {
          // If not JSON, try comma-separated string
          return tags.split(',').map(t => t.trim()).filter(t => t.length > 0)
        }
      }
      return []
    },
    stripHtml (text = '') {
      return (text || '').replace(/<[^>]+>/g, '')
    },
    cutString (text = '') {
      return this.stripHtml(text).slice(0, 70)
    },
    ckeckLength (text) {
      return text.length
    },
    async update_status (id, status) {

      if (status === true) {
        status = false
      } else {
        status = true
      }

      await axios
        .post('/blog/setting/edit/onoff', {
          id,
          status
        }).then(response => (this.onoff_status = response.data))
      if (this.onoff_status.status === true) {
        this.$vs.notify({
          time: 3000,
          color: status === true ? 'success' : 'warning',
          position: 'top-right',
          icon: status === true ? 'check_box' : 'error',
          title: status === true ? 'เปิดแสดงบทความ' : 'ปิดแสดงบทความ'
        })
        this.callinfo()
      } else {
        this.$vs.notify({
          time: 8000,
          color: 'danger',
          position: 'top-right',
          icon: 'error',
          title: this.onoff_status.status === false ? 'เปิดแสดงบทความไม่สำเร็จ!!' : 'ปิดแสดงบทความไม่สำเร็จ!!'
        })
        this.callinfo()
      }
    },
    async uploadFile () {
      await this.onUploadFile2()
    },
    onFileChange (e) {
      const selectedFile = e.target.files[0]
      this.selectedFile = selectedFile
    },
    async  onUploadFile2 () {
      const formData = new FormData()
      formData.append('file', this.selectedFile)
      formData.append('info', this.info)
      formData.append('status', this.status)
      // sending file to the backend
      await axios
        .post('review/upload', formData)
        .then(response => (this.resUpload = response.data))
      if (this.resUpload.status === true) {

        // setTimeout(() => {
        //   window.location.reload()
        // }, 1500)
        await this.$vs.notify({
          time: 10000,
          color: 'success',
          position: 'top-right',
          icon: 'error',
          title: this.resUpload.info.title,
          text: this.resUpload.info.info
        })
        this.info = ''
        this.status = true
        this.selectedFile = []
      } else {
        this.$vs.notify({
          time: 10000,
          color: 'danger',
          position: 'top-right',
          icon: 'error',
          title: this.resUpload.info.title,
          text: this.resUpload.info.info
        })
      }
    },
    async  onUploadFile () {
      const formData = new FormData()
      formData.append('file', this.selectedFile)
      formData.append('topupid', this.agent_error.data)  // appending file

      // sending file to the backend
      await axios
        .post('upload/upload', formData)
        .then(
        //   res => {
        //   console.log(res)
        // }
        )
        .catch(
        //   err => {
        //   console.log(err)
        // }
        )
    },
    retrieveImageFromClipboardAsBlob (pasteEvent, callback) {
      if (pasteEvent.clipboardData === false) {
        if (typeof (callback) === 'function') {
          callback(undefined)
        }
      }

      const items = pasteEvent.clipboardData.items

      if (items === undefined) {
        if (typeof (callback) === 'function') {
          callback(undefined)
        }
      }

      for (let i = 0; i < items.length; i++) {
        // Skip content if not image
        if (items[i].type.indexOf('image') === -1) continue
        // Retrieve image on clipboard as blob
        const blob = items[i].getAsFile()

        if (typeof (callback) === 'function') {
          callback(blob)
        }
      }
    },
    onPasteUrl (evt) {
      // Handle the event for blog_url (รูปด้านหน้า)
      this.retrieveImageFromClipboardAsBlob(evt, (imageBlob) => {
        // If there's an image, display it in the canvas
        if (imageBlob) {
          this.selectedFileUrl = imageBlob
          const canvas = document.getElementById('mycanvas-url')
          if (canvas) {
            const ctx = canvas.getContext('2d')

            // Create an image to render the blob on the canvas
            const img = new Image()

            // Once the image loads, render the img on the canvas
            img.onload = () => {
              // Draw the resized image
              const resizedWidth = 300 // Adjust the resized width as needed
              const resizedHeight = (img.height / img.width) * resizedWidth

              canvas.width = resizedWidth
              canvas.height = resizedHeight

              ctx.drawImage(img, 0, 0, resizedWidth, resizedHeight)
            }

            // Crossbrowser support for URL
            const URLObj = window.URL || window.webkitURL

            // Creates a DOMString containing a URL representing the object given in the parameter
            // namely the original Blob
            img.src = URLObj.createObjectURL(imageBlob)
          }
        }
      })
    },
    onPastePhoto (evt) {
      // Handle the event for blog_photo (รูปภาพด้านในบทความ)
      this.retrieveImageFromClipboardAsBlob(evt, (imageBlob) => {
        // If there's an image, display it in the canvas
        if (imageBlob) {
          this.selectedFilePhoto = imageBlob
          const canvas = document.getElementById('mycanvas-photo')
          if (canvas) {
            const ctx = canvas.getContext('2d')

            // Create an image to render the blob on the canvas
            const img = new Image()

            // Once the image loads, render the img on the canvas
            img.onload = () => {
              // Draw the resized image
              const resizedWidth = 300 // Adjust the resized width as needed
              const resizedHeight = (img.height / img.width) * resizedWidth

              canvas.width = resizedWidth
              canvas.height = resizedHeight

              ctx.drawImage(img, 0, 0, resizedWidth, resizedHeight)
            }

            // Crossbrowser support for URL
            const URLObj = window.URL || window.webkitURL

            // Creates a DOMString containing a URL representing the object given in the parameter
            // namely the original Blob
            img.src = URLObj.createObjectURL(imageBlob)
          }
        }
      })
    }
  }

}

</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}

// Blog Content Preview Styles
.blog-content-preview {
  background-color: #fff;
  border-color: #dae1e7;
  color: #626262;
  
  p, div, span {
    color: inherit;
  }
  
  em {
    color: #b8c2cc;
  }
}

// Quill Editor Styles
.blog-quill-editor {
  min-height: 200px;
  
  .ql-container {
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    font-size: 14px;
    font-family: "Montserrat", 'Mitr', Arial, sans-serif;
    
    .ql-editor {
      min-height: 200px;
      color: #626262;
      
      &.ql-blank::before {
        color: #b8c2cc;
        font-style: normal;
      }
    }
  }
  
  .ql-toolbar {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    border: 1px solid #dae1e7;
    background-color: #f8f8f8;
    
    .ql-stroke {
      stroke: #626262;
    }
    
    .ql-fill {
      fill: #626262;
    }
    
    button:hover,
    button.ql-active {
      .ql-stroke {
        stroke: #7367F0;
      }
      
      .ql-fill {
        fill: #7367F0;
      }
    }
    
    .ql-picker-label {
      color: #626262;
      
      &:hover {
        color: #7367F0;
      }
    }
    
    .ql-picker.ql-expanded .ql-picker-label {
      color: #7367F0;
    }
  }
}

// Dark Theme Support
.theme-dark {
  .blog-quill-editor {
    .ql-container {
      background-color: #262c49;
      border-color: #414561;
      
      .ql-editor {
        color: #c2c6dc;
        
        &.ql-blank::before {
          color: #6e6e6e;
        }
      }
    }
    
    .ql-toolbar {
      background-color: #10163a;
      border-color: #414561;
      
      .ql-stroke {
        stroke: #c2c6dc;
      }
      
      .ql-fill {
        fill: #c2c6dc;
      }
      
      button:hover,
      button.ql-active {
        .ql-stroke {
          stroke: #7367F0;
        }
        
        .ql-fill {
          fill: #7367F0;
        }
      }
      
      .ql-picker-label {
        color: #c2c6dc;
        
        &:hover {
          color: #7367F0;
        }
      }
      
      .ql-picker.ql-expanded .ql-picker-label {
        color: #7367F0;
      }
    }
  }
}

// Tag Modal z-index fix - must be higher than main popup (53000)
// Target all popup wrapper elements with the tag modal class
:deep(.popup-tag-modal) {
  z-index: 53001 !important;
}

// Target the con-vs-popup wrapper when it contains popup-tag-modal
:deep(.con-vs-popup) {
  &:has(.popup-tag-modal) {
    z-index: 53001 !important;
  }
}

// Alternative approach: target by parent structure
:deep(.vs-popup--background) {
  & + .con-vs-popup {
    &:has(.popup-tag-modal) {
      z-index: 53001 !important;
    }
  }
}
</style>
